var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareExclamationWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "square-exclamation",
    clipPath: "url(#clip0_963_3251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.02246 2.5C1.74746 2.5 1.52246 2.725 1.52246 3V13C1.52246 13.275 1.74746 13.5 2.02246 13.5H12.0225C12.2975 13.5 12.5225 13.275 12.5225 13V3C12.5225 2.725 12.2975 2.5 12.0225 2.5H2.02246ZM0.0224609 3C0.0224609 1.89688 0.919336 1 2.02246 1H12.0225C13.1256 1 14.0225 1.89688 14.0225 3V13C14.0225 14.1031 13.1256 15 12.0225 15H2.02246C0.919336 15 0.0224609 14.1031 0.0224609 13V3ZM7.02246 4C7.43809 4 7.77246 4.33437 7.77246 4.75V8.25C7.77246 8.66563 7.43809 9 7.02246 9C6.60684 9 6.27246 8.66563 6.27246 8.25V4.75C6.27246 4.33437 6.60684 4 7.02246 4ZM6.02246 11C6.02246 10.7348 6.12782 10.4804 6.31535 10.2929C6.50289 10.1054 6.75724 10 7.02246 10C7.28768 10 7.54203 10.1054 7.72957 10.2929C7.9171 10.4804 8.02246 10.7348 8.02246 11C8.02246 11.2652 7.9171 11.5196 7.72957 11.7071C7.54203 11.8946 7.28768 12 7.02246 12C6.75724 12 6.50289 11.8946 6.31535 11.7071C6.12782 11.5196 6.02246 11.2652 6.02246 11Z",
    fill: "#FF7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_3251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareExclamationWarning);
export default __webpack_public_path__ + "static/media/square-exclamation-warning.22db6e14e3f9e41a15c09f708077bba6.svg";
export { ForwardRef as ReactComponent };